exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-c63f523c]::-webkit-inner-spin-button,input[data-v-c63f523c]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.tanpawrap[data-v-c63f523c]{white-space:nowrap}", ""]);

// exports
